import React from 'react';
import BadgeBase, { TBadge } from './BadgeBase';
import { BadgeSignals } from '../../types/TEBadgeSignal';

const Dot = (props: Omit<TBadge, 'signal'>) => <BadgeBase {...props} signal={BadgeSignals.Dot} />;

export default Dot;
